import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Request from '../../components/AxiosInstance';
import {useAuthState} from '../../context';
import SendCodeToContact from '../../components/forms/SendCodeToContact';
import SetNewPassword from '../../components/forms/SetNewPassword';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';



export default function ChangePassword() {

	const user = useAuthState().user;
	const navigate = useNavigate();
	const [curStep, setStep] = useState(0);
	const [method, setMethod] = useState('email');

	const handleRetrieveCode = async (method) => {
		try {
			await Request.post('/api/account/pwcode', {method});
			setMethod(method);
			setStep(1);
		} catch (e) {
			console.error(e)
		}
	}

	const handleBack = () => {
		setStep(0);
	}

	const handleSubmitPassword = async (formValue) => {
		try {
			await Request.post('/api/account/chpw', formValue);
			toast.success('You password has been updated.')
			navigate('/acc');
		} catch (e) {
			console.error(e)
		}
	}


	return (
		<Container component="main" maxWidth="xs">
			<Typography variant="h5" gutterBottom>Change Password</Typography>
			{
				curStep === 0 &&
					<SendCodeToContact user={user} handleSubmit={handleRetrieveCode}  />
			}

			{
				curStep === 1 &&
					<SetNewPassword method={method} handleSubmit={handleSubmitPassword} handleBack={handleBack} />
			}


		</Container>
	)
}